@import '~style-sheet-helpers/core.less';

@generatedTableWidth: 780px;

.filters {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  max-width: @generatedTableWidth;
  .first-three-params,
  .remaining-params {
    width: 50%;
  }
}

.first-three-params {
  padding-right: 20px;
}

.remaining-params {
  padding-left: 20px;
}

.filter-input {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;

  && > label {
    font-size: 14px;
    font-weight: @bold;
    line-height: 28px;
  }
}

.dropdown-toggler {
  width: 100%;
  background-color: @white;
  height: 32px;
  border-radius: 4px;
  border: 1px solid var(--grey-550);
  display: flex;
  justify-content: flex-end;
  &:active,
  &:hover {
    background-color: @white;
    border-top: 1px solid var(--grey-550);
  }
}
